// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e8889ea7","228":"2dcaa379","392":"76882b6a","453":"a18a2435","812":"c01636f3","829":"de5e4796","839":"8caad9ab","914":"48c48a99"}[chunkId] + ".chunk.js";
};